import { render } from "./Applicants.vue?vue&type=template&id=642e7948&scoped=true"
import script from "./Applicants.vue?vue&type=script&lang=js"
export * from "./Applicants.vue?vue&type=script&lang=js"

import "./Applicants.vue?vue&type=style&index=0&id=642e7948&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642e7948"]])

export default __exports__